/*
 *
 * UserHeaderBox constants
 *
 */

export const GET_USER_WATCHER = "app/UserHeaderBox/GET_USER_WATCHER"
export const GET_USER_SUCCESS = "app/UserHeaderBox/GET_USER_SUCCESS"
export const GET_USER_FAILED = "app/UserHeaderBox/GET_USER_FAILED"

export const LOGOUT_WATCHER = "app/UserHeaderBox/LOGOUT_WATCHER"

export const UPLOAD_LOGO_WATCHER = "app/UserHeaderBox/UPLOAD_LOGO_WATCHER"
